module.exports = __webpack_public_path__ + "static/media/5f8de7ed5ae7590275f07500_logo_200x200.643d703c.png";